import {CtModelRouteData} from "@ctsolution/ct-framework";

export const UnitsOfMeasurementsRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("unitsofmeasurements");
